module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.7.9-138.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.7.9.md
// module id = 555
// module chunks = 235